'use client';

import {
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Typography,
} from '@musinsa/mds';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import type { PropsWithStyles } from '../../../common';
import { PrivacyPolicyContent } from './PrivacyPolicy/PrivacyPolicyContent';

export const PrivacyPolicyFullView: FC<PropsWithStyles> = ({ className, ...props }) => (
  <div className={twMerge('flex flex-col min-h-screen bg-white', className)} {...props}>
    <BottomSheetTitle>
      <BottomSheetTitleContainer className="px-4 py-3">
        <BottomSheetTitleBox>
          <Typography variant="TextEtc16pxMed">개인정보 수집 및 이용 동의</Typography>
        </BottomSheetTitleBox>
      </BottomSheetTitleContainer>
    </BottomSheetTitle>

    <div className="flex-1 overflow-y-auto bg-white">
      <PrivacyPolicyContent />
    </div>
  </div>
);
